import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSquareInfo: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconSquareInfo"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3V21H21V3H3ZM10 10H13V17H11V12H10V10ZM13 7H11V9H13V7Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSquareInfo;
